
<mat-stepper #stepper [linear]="true">
  <ng-template matStepperIcon="done">
    <mat-icon class="iconDisplay">check_circle</mat-icon>
  </ng-template>

  <mat-step [stepControl]="orgInfo">
    <form [formGroup]="orgInfo">
      <div class="navButtonContainer">
        <button matStepperNext mat-button [disabled]="!orgInfo.valid" (click)="completeStepOne()">Next</button>
    </div>
    <app-organization></app-organization>
      <div class="navButtonContainer">
        <button matStepperNext mat-button [disabled]="!orgInfo.valid" (click)="completeStepOne()">Next</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="thirdFormGroup">
    <ng-template matStepContent>
        <div class="navButtonContainer">
          <button matStepperPrevious mat-button>Back</button>
          <button matStepperNext mat-button>Next</button>
      </div>
    <app-clinician-details></app-clinician-details>
        <div class="navButtonContainer">
          <button matStepperPrevious mat-button>Back</button>
          <button matStepperNext mat-button>Next</button>
      </div>
  </ng-template>

    </mat-step>

  @if (isMeasureSurveyStepVisible()) {
  <mat-step>
    <ng-template matStepContent>
        <div class="navButtonContainer">
          <button mat-button [disabled]="qualityMeasureSurvey.isSaving()" (click)="qualityMeasureSurvey.saveSurveyAndGoBack(stepper)">Back</button>
          <button mat-button [disabled]="qualityMeasureSurvey.isSaving()" (click)="qualityMeasureSurvey.saveSurveyAndAdvance(stepper)">Next</button>
        </div>
        <app-quality-measure-selection-survey #qualityMeasureSurvey></app-quality-measure-selection-survey>
        <div class="navButtonContainer">
          <button mat-button [disabled]="qualityMeasureSurvey.isSaving()" (click)="qualityMeasureSurvey.saveSurveyAndGoBack(stepper)">Back</button>
          <button mat-button [disabled]="qualityMeasureSurvey.isSaving()" (click)="qualityMeasureSurvey.saveSurveyAndAdvance(stepper)">Next</button>
        </div>
  </ng-template>

    </mat-step>
  }

  <mat-step>
    <ng-template matStepContent>
        <div class="navButtonContainer">
          <button  matStepperPrevious mat-button>Back</button>
          <button matStepperNext mat-button>Next</button>
        </div>
        <app-agreement-table></app-agreement-table>
        <div class="navButtonContainer">
          <button  matStepperPrevious mat-button>Back</button>
          <button matStepperNext mat-button>Next</button>
        </div>
  </ng-template>

    </mat-step>

  <mat-step [stepControl]="emrInfo">
    <form [formGroup]="emrInfo">
      <div class="navButtonContainer">
        <button matStepperPrevious mat-button>Back</button>
      </div>
      <app-organization-ehr-form></app-organization-ehr-form>
      <div class="navButtonContainer">
        <button matStepperPrevious mat-button>Back</button>
      </div>
</form>
    </mat-step>
</mat-stepper>
